import { render, staticRenderFns } from "./liveStudentInfo.vue?vue&type=template&id=4331d15a&scoped=true"
import script from "./liveStudentInfo.vue?vue&type=script&lang=js"
export * from "./liveStudentInfo.vue?vue&type=script&lang=js"
import style0 from "./liveStudentInfo.vue?vue&type=style&index=0&id=4331d15a&prod&lang=less"
import style1 from "./liveStudentInfo.vue?vue&type=style&index=1&id=4331d15a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4331d15a",
  null
  
)

export default component.exports